import {Component, Prop,  Watch} from 'vue-property-decorator';
import {CONFIG_ENV} from '@/config';
import {ServiceAdreseLivrare} from '@/services/ServiceAdreseLivrare';
import {TUser} from '@/types/TUser';
import user from '@/store/user';
import eventbus from '@/store/eventbus';
import {getModule} from "vuex-module-decorators";
import {TAdresaLivrare} from "@/types/TAdresaLivrare";
import NomEditAdresaLivrare from "@/components/NomEditAdresaLivrare/NomEditAdresaLivrare.vue"
import extend from 'quasar/src/utils/extend.js';;
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import {Vue, Options} from "vue-class-component";
import EditArticle from "*.vue";
import EventsBus from "@/store/eventbus";

@Options({
    name: "AdminArticles",
    components: {NomEditAdresaLivrare}
})
export default class AdreseLivrare extends Vue {
    public dialogAdresa=false;
    public isAdreseLivrareActivated=false;
    public dialogTransitionShow ='';
    public dialogTransitionHide ='';
    public adrese:TAdresaLivrare[]=[];
    public selectedAdresa:TAdresaLivrare={
        slid:'0',
        appid: '',
        cif: '',
        adresaCodJudet: '',
        adresaLocalitate: '',
        adresaAdresa: '',
        adresaCodPostal: '',
        tipAdresa: '',
        codTara: '',
        navisionid: '',
        denJudet: '',
        isNewAddress: '0'
    }

    declare public $refs: any;
    public userStore = getModule(user);
    public EventBusStore = getModule(EventsBus);

    public onOpenFormAddNewAdresa(){
        //this.selectedUser=puser
        this.selectedAdresa={
            slid:'0',
            appid: '',
            cif: '',
            adresaCodJudet: '',
            adresaLocalitate: '',
            adresaAdresa: '',
            adresaCodPostal: '',
            tipAdresa: '',
            codTara: '',
            navisionid: '',
            denJudet: '',
            isNewAddress: '1'
        };
        if(this.$q.platform.is.mobile){
            this.dialogTransitionShow ='slide-right';
            this.dialogTransitionHide ='slide-left';
        }else{
            this.dialogTransitionShow ='slide-right';
            this.dialogTransitionHide ='slide-left';
        }
        this.dialogAdresa=true;
    }

    public onOpenFormAdresa(padresa:TAdresaLivrare|null){
        if(padresa){
            extend(true, this.selectedAdresa,  padresa);
        }else{
            this.selectedAdresa={
                slid:'0',
                appid: '',
                cif: '',
                adresaCodJudet: '',
                adresaLocalitate: '',
                adresaAdresa: '',
                adresaCodPostal: '',
                tipAdresa: '',
                codTara: '',
                navisionid: '',
                denJudet: '',
                isNewAddress: '1'
            };
        }

        if(this.$q.platform.is.mobile){
            this.dialogTransitionShow ='slide-right';
            this.dialogTransitionHide ='slide-left';
        }else{
            this.dialogTransitionShow ='slide-right';
            this.dialogTransitionHide ='slide-left';
        }
        this.dialogAdresa=true;
    }

    public closeFormEditAdresaLivrare(needRefresh:boolean){
        const vueInst=this;
        vueInst.dialogAdresa=false;
        if(needRefresh){
            vueInst.getAdreseLivrare();
        }
    }

    public onDeleteAdresaLivrare(padresa:TAdresaLivrare){
        const vueInst=this;
        vueInst.$q.dialog({
            title: 'Confirm',
            message: `Stergeti adresa de livrare ${padresa.adresaAdresa}?`,
            cancel: true,
            persistent: true
        }).onOk(() => {
            vueInst.$q.loading.show();
            ServiceAdreseLivrare.deleteAdresaLivrare(padresa).then(response=>{
               if(response.status=='success'){
                   vueInst.getAdreseLivrare();
                   this.$q.notify({
                       color: 'teal',
                       textColor: 'white',
                       icon: 'positive',
                       position: 'top',
                       timeout: 500,
                       message: 'Adresa a fost stearsa!'
                   })
               }
            })
        })
    }

    public get user(): TUser {
        return this.userStore.user;
    }


    public getAdreseLivrare(){
        const vueInst=this;
        vueInst.$q.loading.show();
        vueInst.adrese=[];
        this.userStore.set_screencountadrese(0);
        ServiceAdreseLivrare.getAdreseLivrare().then(response=>{
            if(response.status=='success'){
                vueInst.adrese=JSON.parse(JSON.stringify(response.adrese));
                vueInst.$q.loading.hide()
            }
        })
    }

    @Watch('EventBusStore.event.eventId')
    onEventIdChanged() {
        const vueInst=this;
        if(vueInst.EventBusStore.event.name=='eventClickAddBtn'){
            if(vueInst.isAdreseLivrareActivated){
                vueInst.onOpenFormAddNewAdresa();
            }
        }
    }

    public activated(){
        this.isAdreseLivrareActivated = true;
        this.userStore.set_page_transition('fade-in-right');
        if(this.$q.platform.is.mobile) {
            this.userStore.set_showbackbar(true);
            this.userStore.set_title_back_bar('ADRESE LIVRARE');
        }
        this.getAdreseLivrare();
    }

    public deactivated() {
        this.isAdreseLivrareActivated = false;
    }

}
